import React, { useEffect, useRef, useState } from "react";
import Ellipse from "../../../assets/Ellipse 22.png";
import Frame from '../../../assets/Frame 149.png'


export const AboutUs = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false); 
                }
            },
            {
                threshold: 0.2,
            },
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <section ref={sectionRef} className="py-16 overflow-hidden bg-secondary-50">
            <div className="w-full max-w-7xl mx-auto px-4 overflow-x-hidden">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-16">
                    {/* ================= IMAGE (FROM LEFT) ================= */}
                    <div
                        className={` relative  flex justify-center lg:w-1/2 w-full transition-all duration-1000
                        ${isVisible
                                ? "translate-x-0 opacity-100"
                                : "-translate-x-16 opacity-0"
                            }`}
                    >
                        {/* BIG CIRCLE */}
                        <div className="w-[260px] h-[260px] sm:w-[320px] sm:h-[320px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px] rounded-full shadow-2xl overflow-hidden">
                            <img
                                src={Ellipse}
                                alt="About"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* SMALL CIRCLE */}
                        <div className="absolute bottom-0 left-1/2 -translate-x-[120%] sm:-translate-x-[110%] lg:-translate-x-[100%] w-[100px] h-[100px] sm:w-[140px] sm:h-[140px] md:w-[180px] md:h-[180px]  lg:w-[220px] lg:h-[220px]  rounded-full overflow-hidden ">
                            <img
                                src={Frame}
                                alt="About Small"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* ================= CONTENT (FROM RIGHT) ================= */}
                    <div
                        className={`w-full  transition-all duration-1000
                        ${isVisible
                                ? "translate-x-0 opacity-100"
                                : "translate-x-16 opacity-0"
                            }`}
                    >
                        <div className="flex  mb-4">
                            <h2 className="flex items-center gap-3  bg-blue-100  text-blue-600    px-4 py-1 rounded-full  text-sm   font-medium shadow-sm">
                                <span className="w-4 h-4 rounded-full    border-2 border-blue-500  flex items-center justify-center">
                                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                                </span>
                                About Us
                            </h2>
                        </div>
                        <h3 className="text-black text-3xl sm:text-4xl lg:text-5xl  font-bold mb-3 leading-tight ">
                            Shaping Futures Through Industry Focused Learning
                        </h3>
                        <p className=" text-gray-600 text-lg  mb-4">
                            <span className="text-primary-600 font-semibold ">San LMS</span>{" "}
                            <span className="text-lg text-gray-600 leading-loose mb-6">
                                is a leading online learning platform focused on high-demand
                                skill development and structured learning paths.We bridge the
                                gap between academic education and real-world industry
                                requirements.Our programs are designed to be
                                career-focused.Learners gain job-ready skills for modern and
                                technology driven industries.We offer training in UI/UX, Data
                                Analytics, AI, Software Development, Mechanical, and Embedded
                                systems.Our goal is to empower students for long-term career
                                success.
                            </span>
                        </p>



                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 my-8 ">
                            <div className="bg-white border rounded-2xl p-4 sm:p-5 text-center shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer">
                                <p className="text-xl sm:text-2xl lg:text-3xl font-semibold text-primary-600">
                                    100+
                                </p>
                                <p className="text-xl text-primary-600 mt-1">
                                    Courses
                                </p>
                            </div>

                            <div className="bg-white border rounded-2xl p-4 sm:p-5 text-center shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer">
                                <p className="text-xl sm:text-2xl lg:text-3xl font-semibold text-primary-600">
                                    25+
                                </p>
                                <p className="text-xl text-primary-600 mt-1">
                                    Mentors
                                </p>
                            </div>

                            <div className="bg-white border rounded-2xl p-4 sm:p-5 text-center shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer">
                                <p className="text-xl sm:text-2xl lg:text-3xl font-semibold text-primary-600">
                                    500+
                                </p>
                                <p className=" text-xl text-primary-600 mt-1">
                                    Learners
                                </p>
                            </div>
                        </div>

                        <button
                            onClick={()=>window.location.href = '/about'}
                            type="submit"
                            className="flex justify-start gap-2 text-primary-600 text-xl bg-gray-50 backdrop-blur-md lg:font-medium isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-primary-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-6 py-3 overflow-hidden border-2 rounded-xl group items-center"
                        >
                            Know More
                            <svg
                                className="w-6 h-6 justify-end group-hover:rotate-90 duration-300 rounded-full border border-gray-700 group-hover:border-none p-1 rotate-45"
                                viewBox="0 0 16 19"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                    className="fill-gray-800 group-hover:fill-white"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};